import { render, staticRenderFns } from "./ErrorIconAnim.vue?vue&type=template&id=7c9961be&scoped=true"
import script from "./ErrorIconAnim.vue?vue&type=script&lang=js"
export * from "./ErrorIconAnim.vue?vue&type=script&lang=js"
import style0 from "./ErrorIconAnim.vue?vue&type=style&index=0&id=7c9961be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9961be",
  null
  
)

export default component.exports